import { render } from "./CIS-Steps-Carousel-Item.vue?vue&type=template&id=4d1398dd&scoped=true"
import script from "./CIS-Steps-Carousel-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Steps-Carousel-Item.vue?vue&type=script&lang=js"

import "./CIS-Steps-Carousel-Item.vue?vue&type=style&index=0&id=4d1398dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1398dd"]])

export default __exports__